module.exports = __webpack_public_path__ + "static/media/autosign-off.e9c3463a.svg";